import React, { useContext } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import { bindActionCreators, Dispatch } from "redux";

import { Dialog as DialogComponent, OkButton, Overlay } from "@plex/react-components";

import { DialogContainer, DialogContext } from "ui/app/navigation";
import { MessageTranslations } from "ui/screens/translation-managers/message-details/message-translations";
import { messageTranslationsActions } from "ui/screens/translation-managers/message-details/message-translations/MessageTranslations.actions";
import { IMessageTranslationState } from "ui/screens/translation-managers/message-details/message-translations/MessageTranslations.state";

interface IMessageTranslationProps {
  messageId: string;
  isLoading: boolean;
  clearState: () => void;
}

export const AllMessageTranslations: React.FC<IMessageTranslationProps & RouteComponentProps> = ({ messageId, isLoading, clearState }) => {
  const dialogContext = useContext(DialogContext);

  const mainContent = (
    <>
      <Overlay show={isLoading} showSpinner />
      <MessageTranslations messageId={messageId} />
    </>
  );

  return (
    <>
      <DialogContainer
        onHidden={clearState}
        render={dialogProps => {
          return (
            <DialogComponent {...dialogProps}>
              <DialogComponent.Body>{mainContent}</DialogComponent.Body>
              <DialogComponent.Footer>
                <OkButton onClick={dialogProps.onHide} />
              </DialogComponent.Footer>
            </DialogComponent>
          );
        }}
      />
      {!dialogContext.isOpened && mainContent}
    </>
  );
};

export default connect(
  (state: { messageTranslations: IMessageTranslationState }) => {
    return {
      state: state.messageTranslations,
      isLoading: state.messageTranslations.isLoading
    };
  },
  (dispatch: Dispatch) =>
    bindActionCreators(
      {
        clearState: messageTranslationsActions.clearState
      },
      dispatch
    )
)(AllMessageTranslations);
